import { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons"
import { Card, Col, Container, Dropdown, Nav, Row } from "react-bootstrap"
import useLocalStorageState from "use-local-storage-state"
import { toast } from "sonner"
import { formatDate } from "../../../Utils/helpers/commonhelper"
import { defaultImage, imageURL } from "../../../Utils/constants/constant"
import { TableWrapper } from "../../../CommonComponents/TableWrapper"
import pugCrm_favicon from "../../../Utils/assets/img/pugCrm_favicon.png"

export const ProjectListing = ({
    projectListData,
    cardData,
    offset,
    setOffset,
    limit,
    setLimit,
    totalItems,
    isLoading,
    columns,
    handlePageChange,
    handleDetailPageClicked,
    handleProjectEditClicked,
    handleMarkedAsComplete,
    onDelete,
    setProjectOffcanvas,
}) => {
    // rbac permission object
    const [PERMISSION, _] = useLocalStorageState("permission")
    const projectGrant = PERMISSION?.project

    const [openDropdownId, setOpenDropdownId] = useState(null)

    const hasData = projectListData?.length > 0
    const currPageItems = projectListData?.length

    const displayStartItem = totalItems === 0 ? 0 : offset * limit + 1
    const displayEndItem =
        totalItems === 0 ? 0 : Math.min(offset * limit + limit, totalItems)

    const tableHeader = () => (
        <thead style={{ zIndex: 101 }}>
            <tr>
                <th
                    className="text-start pinned-column last-pinned-column bulk-selection-cell customize-cell-width"
                    style={{ width: 60, minWidth: 60, maxWidth: 60, left: 0 }}
                >
                    <span>#</span>
                </th>
                {columns?.map((col, index) => (
                    <th key={`header-${index}`}>{col}</th>
                ))}
                <th>
                    Action{" "}
                    <i className="fa-solid fa-sort" style={{ fontSize: "0.6rem" }}></i>
                </th>
            </tr>
        </thead>
    )

    const tableBody = () =>
        projectListData?.map((project, index) => (
            <tr key={project.id}>
                <td>{offset * limit + (index + 1)}</td>

                {columns?.map((col, cellIndex) => {
                    switch (col) {
                        case "Contact":
                            return (
                                <td
                                    key={`cell-${index}-${cellIndex}`}
                                    className="text-primary"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleDetailPageClicked(project)}
                                >
                                    <div className="d-flex align-items-center">
                                        <img
                                            src="https://dev.pandalms.com/upload/default/female.jpg"
                                            alt="Employee Photo"
                                            style={{
                                                width: "28px",
                                                height: "28px",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                            }}
                                        />
                                        <div className="px-2">
                                            <div title={project?.contact_name}>
                                                {project?.contact_name?.length > 18
                                                    ? `${project.contact_name.slice(0, 18)}...`
                                                    : project?.contact_name || "-"}
                                            </div>
                                            <div
                                                className="text-muted"
                                                style={{ fontWeight: 400, fontSize: "0.75rem" }}
                                                title={project?.email}
                                            >
                                                {project?.email?.length > 15
                                                    ? `${project.email.slice(0, 15)}...`
                                                    : project?.email || "-"}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            )

                        case "Project":
                            return (
                                <td
                                    key={`cell-${index}-${cellIndex}`}
                                    className="text-primary"
                                    style={{ cursor: "pointer" }}
                                    title={project?.project_title}
                                    onClick={() => handleDetailPageClicked(project)}
                                >
                                    {project?.project_title?.length > 25
                                        ? `${project.project_title.slice(0, 25)}...`
                                        : project?.project_title || "-"}
                                </td>
                            )

                        case "Description":
                            return (
                                <td
                                    key={`cell-${index}-${cellIndex}`}
                                    title={project?.description}
                                >
                                    {project?.description?.length > 20
                                        ? `${project.description.slice(0, 20)}...`
                                        : project?.description || "-"}
                                </td>
                            )

                        case "Teams":
                            return (
                                <td key={`cell-${index}-${cellIndex}`}>
                                    <div className="avatar-list-stacked">
                                        {project?.users && project?.users?.length > 0 ? (
                                            <>
                                                {project?.users.slice(0, 3).map((member, idx) => (
                                                    <span
                                                        key={idx}
                                                        className="avatar avatar-sm avatar-rounded"
                                                    >
                                                        <img
                                                            height="20px"
                                                            width="20px"
                                                            title={member?.user_name}
                                                            src={
                                                                member.profile_img === null ||
                                                                    member.profile_img === "null"
                                                                    ? defaultImage
                                                                    : `${imageURL}${member.profile_img}`
                                                            }
                                                            alt={member.name || "User"}
                                                            className="avatar-item"
                                                        />
                                                    </span>
                                                ))}
                                                {project.users?.length > 3 && (
                                                    <div className="avatar avatar-sm bg-primary avatar-rounded text-fixed-white">
                                                        +{project?.users.length - 3}
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img
                                                    src={defaultImage || "/placeholder.svg"}
                                                    alt="Dummy User"
                                                    className="avatar-item"
                                                />
                                            </span>
                                        )}
                                    </div>
                                </td>
                            )

                        case "Start Date":
                            return (
                                <td key={`cell-${index}-${cellIndex}`}>
                                    {formatDate(project.start_date)}
                                </td>
                            )

                        case "End Date":
                            return (
                                <td key={`cell-${index}-${cellIndex}`}>
                                    {formatDate(project.end_date)}
                                </td>
                            )

                        default:
                            return <td key={`cell-${index}-${cellIndex}`}>-</td>
                    }
                })}

                {/* Actions column */}
                <td
                    key={`actions-${index}`}
                    style={{
                        zIndex: openDropdownId === project.id ? 11 : "auto",
                        textAlign: "center",
                    }}
                >
                    <Dropdown
                        as="div"
                        show={openDropdownId === project.id}
                        onToggle={(isOpen) => {
                            if (project?.project_status === "complete") {
                                toast.warning(
                                    "This project is already marked as completed. You cannot perform any action.",
                                )
                                return
                            }
                            setOpenDropdownId(isOpen ? project.id : null)
                        }}
                        className="dropdownsWithoutToggle h-100 d-flex align-items-center justify-content-center"
                    >
                        <Dropdown.Toggle
                            className="header-link"
                            as={Nav.Link}
                            style={{ cursor: "pointer", padding: 0 }}
                        >
                            <FontAwesomeIcon
                                icon={faEllipsisVertical}
                                style={{ fontSize: "16px", color: "#64748b" }}
                            />
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end" className="dropdown-menu">
                            <Dropdown.Item
                                href="#"
                                className="d-flex align-items-center"
                                onClick={() => {
                                    if (!projectGrant?.isEdit) {
                                        toast.warning("You are not authorized for this action!")
                                        return
                                    }
                                    handleProjectEditClicked(project)
                                }}
                            >
                                Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                                href="#"
                                className="d-flex align-items-center"
                                onClick={() => {
                                    if (!projectGrant?.isDelete) {
                                        toast.warning("You are not authorized for this action!")
                                        return
                                    }
                                    onDelete(project.id)
                                }}
                            >
                                Delete
                            </Dropdown.Item>
                            <Dropdown.Item
                                href="#"
                                className="d-flex align-items-center"
                                onClick={() => {
                                    if (!projectGrant?.isEdit) {
                                        toast.warning("You are not authorized for this action")
                                        return
                                    }
                                    handleMarkedAsComplete(project)
                                }}
                            >
                                Mark Complete
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </td>
            </tr>
        ))

    const pageCount = Math.ceil((totalItems || 0) / limit)

    return (
        <>
            <div
                style={{
                    textAlign: "end",
                    paddingRight: "3px",
                    color: "#8798adcc",
                    fontWeight: "300",
                    fontSize: "11px",
                    textTransform: "capitalize",
                    marginTop: "-19px",
                }}
            >
                Customize Column View | Filter Project | Short by ascending &
                Descending Order
            </div>

            <Row className="g-3 mt-2 mb-0">
                <Col sm={4}>
                    <Card
                        className="shadow-sm rounded-3 p-0 w-100 h-100"
                        style={{ backgroundColor: "#ffffff", border: "1px solid #e3e3e3" }}
                    >
                        <Card.Body className="p-3">
                            <div className="d-flex align-items-center justify-content-between mb-1">
                                <span className="text-dark fw-medium" style={{ fontSize: "14.5px" }}>
                                    Completed Projects
                                </span>
                                <span
                                    className="badge rounded-pill fw-semibold border"
                                    style={{
                                        backgroundColor: "#f0fdf4",
                                        color: "#15803d",
                                        borderColor: "#bbf7d0",
                                        fontSize: "10px",
                                    }}
                                >
                                    +1.5%
                                </span>
                            </div>
                            <div className="d-flex align-items-baseline gap-2">
                                <h4 className="mb-0 fw-normal" style={{ fontSize: "2rem" }}>
                                    {cardData?.completed || 0}
                                </h4>
                                <span className="text-muted" style={{ fontSize: "11.5px" }}>
                                    this month
                                </span>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col sm={4}>
                    <Card
                        className="shadow-sm rounded-3 p-0 w-100 h-100"
                        style={{ backgroundColor: "#ffffff", border: "1px solid #e3e3e3" }}
                    >
                        <Card.Body className="p-3">
                            <div className="d-flex align-items-center justify-content-between mb-1">
                                <span className="text-dark fw-medium" style={{ fontSize: "14.5px" }}>
                                    Total Projects
                                </span>
                                <span
                                    className="badge rounded-pill fw-semibold border"
                                    style={{
                                        backgroundColor: "#f0fdf4",
                                        color: "#15803d",
                                        borderColor: "#bbf7d0",
                                        fontSize: "10px",
                                    }}
                                >
                                    +0.67%
                                </span>
                            </div>
                            <div className="d-flex align-items-baseline gap-2">
                                <h4 className="mb-0 fw-normal" style={{ fontSize: "2rem" }}>
                                    {cardData?.total || 0}
                                </h4>
                                <span className="text-muted" style={{ fontSize: "11.5px" }}>
                                    this month
                                </span>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col sm={4}>
                    <Card
                        className="shadow-sm rounded-3 p-0 w-100 h-100"
                        style={{ backgroundColor: "#ffffff", border: "1px solid #e3e3e3" }}
                    >
                        <Card.Body className="p-3">
                            <div className="d-flex align-items-center justify-content-between mb-1">
                                <span className="text-dark fw-medium" style={{ fontSize: "14.5px" }}>
                                    Overdue Projects
                                </span>
                                <span
                                    className="badge rounded-pill fw-semibold border"
                                    style={{
                                        backgroundColor: "#fef2f2",
                                        color: "#b91c1c",
                                        borderColor: "#fecdd3",
                                        fontSize: "10px",
                                    }}
                                >
                                    0.23%
                                </span>
                            </div>
                            <div className="d-flex align-items-baseline gap-2">
                                <h4 className="mb-0 fw-normal" style={{ fontSize: "2rem" }}>
                                    {cardData?.overdue || 0}
                                </h4>
                                <span className="text-muted" style={{ fontSize: "11.5px" }}>
                                    this month
                                </span>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Container
                fluid
                style={{
                    fontFamily: "'Poppins', sans-serif",
                    height: "calc(100vh - 20rem)",
                    padding: 0,
                    animation: "cardEntry 1s ease-out forwards",
                }}
                className="mt-3 p-0"
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        width: "100%",
                        borderRadius: "7px",
                    }}
                    className="position-relative container-table"
                >
                    {!hasData && !isLoading ? (
                        <div
                            className="d-flex flex-column justify-content-center align-items-center bg-white"
                            style={{ width: "100%", height: "100%", minHeight: "400px" }}
                        >
                            <div
                                className="d-flex flex-column align-items-center justify-content-center gap-3"
                                style={{ width: "98%", height: "300px", maxHeight: "350px" }}
                            >
                                <img src={pugCrm_favicon || "/placeholder.svg"} alt="" height={"50px"} />
                                <div
                                    className="d-flex flex-column justify-content-center align-items-center gap-2"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setProjectOffcanvas(true)}
                                >
                                    <p>Create your project</p>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <TableWrapper
                            isLoading={isLoading}
                            hasData={hasData}
                            tableHeader={tableHeader()}
                            tableBody={tableBody()}
                            displayStartItem={displayStartItem}
                            displayEndItem={displayEndItem}
                            totalItems={totalItems}
                            currPageItems={currPageItems}
                            offset={offset}
                            setOffset={setOffset}
                            limit={limit}
                            setLimit={setLimit}
                            handlePageChange={handlePageChange}
                            effectivePageCount={pageCount}
                            columnLabels={columns}
                        />
                    )}
                </div>
            </Container>
        </>
    )
}